<template>
  <div>
    <v-layout row>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">
            Import Products
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <a
              id="xlsxfile"
              href="/static/files/acuify-bulk-import.xlsx"
              download
              style="display: none"
              >www</a
            >
            <v-btn @click="downloadFile()" color="primary" outlined large class="white--text">
              <v-icon left dark> download_for_offline </v-icon>
              Download Template
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-card>
          <v-card-text style="min-height: 500px; padding: 20% 35%" v-if="selectedBrand">
              <v-select
                item-text="name"
                return-object
                :items="firmsByBrand"
                v-model="currentFirm"
                label="Select Firms"
              ></v-select>
            <input
              type="file"
              :disabled="!currentFirm"
              @change="dataImport($event)"
            />
          </v-card-text>
          <v-snackbar v-model="snackbar">
            Product Data imported Successfully

            <template v-slot:action="{ attrs }">
              <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import _ from "lodash";
import XLSX from 'xlsx';
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      currentFirm: null,
      mobileRules: /^(\+91|\+91\-|0)?[6789]\d{9}$/,
      emailRules: /.@./,
      progressBar : false,
      bufferValue : 0,
      progressVal : 0,
      snackbar : false
    };
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
  },
  watch: {
  },
  firestore: {},
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    firmsByBrand () {
            return this.firms.filter((item) => 
                item['brand'] === this.selectedBrand
            )
    }
  },
  methods: {
    downloadFile() {
      document.getElementById("xlsxfile").click();
    },
    addProductData(data){
      let product = {
        brand: this.selectedBrand,
        firm : this.currentFirm['.key'],
        name : data['Product Name']
      };

      if(data['Active']) {
        product.isActive = data['Active'] == "YES";
      }

      if(data['Product Description']) {
        product.description = data['Product Description'];
      }

      if(data['Product Barcode']) {
        product.barcode = data['Product Barcode'];
      }

      if(data['Alert Quantity']) {
        product.alertQuantity = this.getNumber(data['Alert Quantity'],true);
      }

      if(data['GST type']) {
        product.GST_type = data['GST type'];
      }

      product.taxableGST_rate = data['Taxable GST rate'] ? this.getNumber(data['Taxable GST rate'],false) : 0;
    

      product.HSN_code =  this.getNumber(data['HSN code'],true) || 0;
  
      if(data['Unit']) {
        product.unit = data['Unit'];
      }

      if(data['Opening Date']) {
        let date = this.getFormattedDate(data['Opening Date']);
        if (this.isValidDate(date)) {
          product["openingDate"] = date.getTime();
        }
      }

      if(data['Opening Quantity']) {
        product.quantity = this.getNumber(data['Opening Quantity'],true);
        product.purchaseQuantity = 0;
        product.saleQuantity = 0;
        product.openingQuantity = product.quantity;
      }

      if(data['Opening Amount']) {
        product.openingBalance = this.getNumber(data['Opening Amount'],false);
      }

      if(data['Purchasing Price [Excluding GST]']) {
        product.purchasingPrice = this.getNumber(data['Purchasing Price [Excluding GST]'],false);
      }

      if(data['Selling Price [Excluding GST]']) {
        product.sellingPrice = this.getNumber(data['Selling Price [Excluding GST]'],false);
      }

      if(data['MRP [Including GST]']) {
        product.MRPRate = this.getNumber(data['MRP [Including GST]'],false);
      }
      this.$root.$firebaseRefs.products.push(product);
    },
    getFormattedDate(date) {
      if(date.indexOf("/") > 0) {
          return new Date(
            date.split("/")[1] + "/" + date.split("/")[0] + "/" + date.split("/")[2]
          );
      } else if(date.indexOf("-") > 0) {
        return new Date(
            date.split("-")[1] + "/" + date.split("-")[0] + "/" + date.split("-")[2]
          );
      }

    },
    getNumber(a,isInt){
      let temp = isInt ? parseInt(a) : Number.parseFloat(a);
      return isNaN(temp) ? 0 : temp;
    },
      isValidDate(d) {
      if (Object.prototype.toString.call(d) === "[object Date]") {
        // it is a date
        if (isNaN(d.getTime())) {
          // d.valueOf() could also work
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    dataImport(e) {
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      reader.onload =  (e)=> {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        if (workbook.Sheets.auth.H1.h == "4ACvPW6LwZrucLtVOoBL") {
          if (confirm("Are you sure you want to import this data?")) {
            let productWorksheet = workbook.Sheets['Products'];
             let productData = XLSX.utils.sheet_to_json(productWorksheet, { raw: false });
            productData.map((product) => {
                if(product['Product Name']) {
                    this.addProductData(product);
                    console.log(product)
                }
            });
            this.snackbar = true;
          }
        } else {
          alert("Please upload valid file from template.");
        }
      };
      reader.readAsArrayBuffer(f);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/DataManagement/ImportFromExcel.vue